import classNames from 'classnames'
import React from 'react'
import { IconType } from '../../utils/types'
import './Input.sass'

interface InputProps {
  className?: string
  colored?: boolean
  placeholder?: string
  withRightPadding?: boolean
  Icon?: IconType
  lightMode?: boolean
  [x: string]: any
}

export const Input: React.FC<InputProps> = (props) => {
  const {
    className,
    colored = false,
    Icon = null,
    placeholder,
    withRightPadding,
    lightMode,
    ...rest
  } = props
  const inputContainerPrfx = 'input-container'
  const inputContainerCls = classNames(inputContainerPrfx, {
    [`${className}`]: className,
  })
  const inputPrfx = 'input'
  const inputCls = classNames(inputPrfx, {
    [`${inputPrfx}_colored`]: colored === true,
    [`${inputPrfx}_with-icon`]: Icon,
    [`${inputPrfx}_with-icon`]: withRightPadding === true,
    [`${inputPrfx}_type_light`]: lightMode === true,
  })
  return (
    <div className={inputContainerCls}>
      <input className={inputCls} placeholder={placeholder} {...rest} />
      {Icon && <Icon className={`${inputContainerPrfx}__icon`} />}
    </div>
  )
}
